var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3875 10.2375C6.475 10.325 6.5625 10.4125 6.65 10.4125C6.7375 10.5 6.9125 10.5 7 10.5C7.0875 10.5 7.2625 10.5 7.35 10.4125C7.4375 10.325 7.525 10.325 7.6125 10.2375L11.1125 6.7375C11.4625 6.3875 11.4625 5.8625 11.1125 5.5125C10.7625 5.1625 10.2375 5.1625 9.8875 5.5125L7.875 7.525V0.875C7.875 0.35 7.525 0 7 0C6.475 0 6.125 0.35 6.125 0.875V7.525L4.1125 5.5125C3.7625 5.1625 3.2375 5.1625 2.8875 5.5125C2.5375 5.8625 2.5375 6.3875 2.8875 6.7375L6.3875 10.2375Z",
    fill: "#FF00E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.875C12.6 7.875 12.25 8.225 12.25 8.75V10.5C12.25 11.4625 11.4625 12.25 10.5 12.25H3.5C2.5375 12.25 1.75 11.4625 1.75 10.5V8.75C1.75 8.225 1.4 7.875 0.875 7.875C0.35 7.875 0 8.225 0 8.75V10.5C0 12.425 1.575 14 3.5 14H10.5C12.425 14 14 12.425 14 10.5V8.75C14 8.225 13.65 7.875 13.125 7.875Z",
    fill: "#FF00E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1fcfe0b00daeec9021e19c04921f3089.svg";
export { ForwardRef as ReactComponent };